export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Обработка ввода логина (email или телефон РФ)
export function formatLoginValue(raw) {
  // Если есть буквы или @ — считаем это email и не форматируем как телефон
  if (/[A-Za-z@]/.test(raw)) {
    return {
      value: raw,
      isEmailCandidate: true,
    };
  }

  // Телефон РФ
  let digits = raw.replace(/\D/g, '');

  if (digits.startsWith('8')) {
    digits = '7' + digits.slice(1);
  } else if (!digits.startsWith('7') && digits.length > 0) {
    digits = '7' + digits;
  }

  if (digits.length > 11) {
    digits = digits.slice(0, 11);
  }

  let formatted = '';

  if (digits.length > 0) {
    formatted = '+7';
  }

  if (digits.length > 1) {
    formatted += '-(' + digits.slice(1, 4);
    if (digits.length >= 4) {
      formatted += ')';
    }
  }

  if (digits.length >= 5) {
    formatted += '-' + digits.slice(4, 7);
  }

  if (digits.length >= 8) {
    formatted += '-' + digits.slice(7, 9);
  }

  if (digits.length >= 10) {
    formatted += '-' + digits.slice(9, 11);
  }

  return {
    value: formatted,
    isEmailCandidate: false,
  };
}

// Проверка валидности логина (email или телефон РФ)
export function isLoginValid(value) {
  const trimmed = value.trim();

  if (!trimmed) {
    return false;
  }

  if (trimmed.includes('@')) {
    return EMAIL_REGEX.test(trimmed);
  }

  const digits = trimmed.replace(/\D/g, '');
  return digits.length === 11;
}

